
const initTrustedBy1Sections = () => {
    [...document.querySelectorAll('.trusted-by-section')]
        .filter(item => item.dataset.init !== 'true')
        .forEach((item) => initTrustedBy1Section(item));
};

const initTrustedBy1Section = (section) => {
    section.dataset.init = true;

};

export { initTrustedBy1Sections };